import {
  EDIT_BLOG_POST,
  EDIT_BLOG_POST_SUCCESS,
  EDIT_BLOG_POST_FAILED
} from './constants';
import db from '../../firebaseAPI';


export function editBlogPostRequest() {
  return {
    type: EDIT_BLOG_POST,
    payload: {},
  };
}


export function editBlogPostSuccess(post) {
  // LocalStorage.setItem('token', response.header['x-session-id']);

  return {
    type: EDIT_BLOG_POST_SUCCESS,
    payload: {
      
    },
  };
}

export function editBlogPostFailed(postId, payload) {
  return {
    type: EDIT_BLOG_POST_FAILED,
    payload: {
      postId,
      data: { ...payload },
    },
  };
}

function editBlogPost(postId, data) {
  return (dispatch) => {
    dispatch(editBlogPostRequest());
    return db
      .collection('posts')
      .doc(postId)
      .update(data)
      .then(function (doc) {
        dispatch(editBlogPostSuccess());
      })
      .catch(function (error) {
        dispatch(editBlogPostFailed(error));
      });
  };
}

export default editBlogPost;





// WEBPACK FOOTER //
// ./src/modules/blog/editBlogPost.js